import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/layouts/app.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/layouts/default.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/layouts/landing.vue").then(m => m.default || m))
}